const { forEachElement } = require('../common/utils/dom');
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');
const clientSideValidation = require('./clientSideValidation');

const analyticsEventBus = getAnalyticsEventBus();

const getEmailInput = (form) =>
  form.querySelector('input[name=hpEmailSignUp--home]') ||
  form.querySelector('input[name=hpEmailSignUp]');
const getBylDataCheck = (form) => form.querySelector('input[name=bylData]');

const resetForm = (form) => {
  const email = getEmailInput(form);
  const bylDataCheck = getBylDataCheck(form);
  const newsletterFeedback = form.querySelector('.invalid-feedback');
  const isEmptyCheck = form.querySelector('.form-empty-check');
  email.value = '';
  bylDataCheck.checked = false;
  newsletterFeedback.innerText = '';
  isEmptyCheck.innerText = '';
};

const showSubmitting = (form) => {
  const newsletterModalContainer = form.parentElement;

  newsletterModalContainer.classList.remove(
    'newsletter-modal-container--feedback'
  );
  newsletterModalContainer.classList.add(
    'newsletter-modal-container--submitting'
  );
};

const showFeedbackTwoElements = (form, errorCheck, errorEmail) => {
  const button = form.querySelector('.subscribe-email.interaction--swap-text');
  $('body').trigger('interaction--swap-text-event', button);

  const newsletterModalContainer = form.parentElement;
  newsletterModalContainer.classList.remove(
    'newsletter-modal-container--submitting'
  );

  const newsletterFeedback = form.querySelector('.invalid-feedback');
  newsletterFeedback.innerText = errorEmail;
  const isEmptyCheck = form.querySelector('.form-empty-check');
  isEmptyCheck.innerText = errorCheck;
};

const showFeedbackOneElement = (form, error, type) => {
  const button = form.querySelector('.subscribe-email.interaction--swap-text');
  $('body').trigger('interaction--swap-text-event', button);

  const newsletterModalContainer = form.parentElement;
  newsletterModalContainer.classList.remove(
    'newsletter-modal-container--submitting'
  );

  if (error) {
    if (type === 'emailId') {
      const newsletterFeedback = form.querySelector('.invalid-feedback');
      newsletterFeedback.innerText = error;
    } else if (type === 'bylDataCheck') {
      const isEmptyCheck = form.querySelector('.form-empty-check');
      isEmptyCheck.innerText = error;
    }
  }
};

const showFeedback = (form) => {
  const button = form.querySelector('.subscribe-email.interaction--swap-text');
  $('body').trigger('interaction--swap-text-event', button);

  const newsletterModalContainer = form.parentElement;
  newsletterModalContainer.classList.remove(
    'newsletter-modal-container--submitting'
  );

  newsletterModalContainer.classList.add(
    'newsletter-modal-container--feedback'
  );
  setTimeout(() => {
    newsletterModalContainer.classList.remove(
      'newsletter-modal-container--feedback'
    );
    resetForm(form);
  }, 5000);

  // Send info for Analytics
  const landingNewsletter = document.querySelector(
    '.page--email-subscribe-landing'
  );
  const footerNewsletter = document.querySelector(
    '.footer--newsletter-show .newsletter-modal-container.interaction--modal-newsletter'
  );
  let location;
  if (footerNewsletter) {
    location =
      analyticsEventBus.EVENTS.PAYLOADS.newsletterSubscribed.location.footer;
  } else if (landingNewsletter) {
    location =
      analyticsEventBus.EVENTS.PAYLOADS.newsletterSubscribed.location
        .landingSubscribe;
  } else {
    location =
      analyticsEventBus.EVENTS.PAYLOADS.newsletterSubscribed.location.home;
  }
  analyticsEventBus.publish(
    analyticsEventBus.EVENTS.newsletterSubscribed,
    location
  );
};

const handleSubmit = (e) => {
  e.preventDefault();
  const form = e.target;
  const url = form.getAttribute('action');
  const email = getEmailInput(form);
  const bylDataCheck = getBylDataCheck(form);
  const newsletterFeedback = form.querySelector('.invalid-feedback');

  if (!bylDataCheck.checked) {
    showFeedbackOneElement(
      form,
      bylDataCheck.dataset?.missingError,
      'bylDataCheck'
    );
    bylDataCheck.classList.add('is-invalid');
    clientSideValidation.functions.validateFormatData(form);
    if (!email.validity.valid) {
      return;
    }
    if (email.validity.valid) {
      if (newsletterFeedback.innerText !== '') {
        newsletterFeedback.innerText = '';
        bylDataCheck.classList.remove('is-invalid');
      }
      return;
    }
  }

  if (bylDataCheck.checked) {
    clientSideValidation.functions.validateFormatData(form);
    if (email.validity.valid) {
      showSubmitting(form);
    }
  }

  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: {
      emailId: email.value,
      bylDataCheck: bylDataCheck.checked,
    },
    success(data) {
      if (data.error) {
        if (data.bothBlank) {
          showFeedbackTwoElements(form, data.msgCheck, data.msgEmail);
        } else if (data.typeEmail) {
          showFeedbackOneElement(form, data.msg, 'emailId');
        } else if (data.typeCheck) {
          showFeedbackOneElement(form, data.msg, 'bylDataCheck');
        }
      } else if (data.success) {
        showFeedback(form);
      }
    },
    error(err) {
      showFeedback(form, err.msg);
    },
  });
};

module.exports = () => {
  forEachElement(document.querySelectorAll('.newsletter-form'), (item) => {
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    item.addEventListener('submit', handleSubmit);
  });
};
